export default (Vue) => {
  const files = require.context('../components', false, /\.vue$/)
  files.keys().forEach(key => {
    Vue.component(key.split('/')[1].replace(/\.vue$/, ''), files(key).default)
  })
}
